import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import gql from "graphql-tag";

const SINGLE_VEHICLE_TYPE = gql`
  query SystemCodes($where: SystemCodeWhereInput) {
    SystemCodes(where: $where) {
      RecId
    }
  }
`;

const ALL_VEHICLES_SELECT_QUERY = gql`
  query Vehicles($where: VehicleWhereInput) {
    Vehicles(where: $where, orderByMulti: [VehicleNumber_ASC]) {
      RecId
      VehicleNumber
      Description
      StatusRecIdRef
      Status {
        RecId
        CodeId
      }
    }
  }
`;

const useTrailers = where => {
  const client = useApolloClient();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(false);
        const {
          data: { SystemCodes: [SystemCode] = [null] }
        } = await client.query({
          query: SINGLE_VEHICLE_TYPE,
          variables: {
            where: {
              Category: "Fleet",
              CodeName: "VehicleType",
              CodeDescription: "Trailer"
            }
          }
        });

        if (SystemCode) {
          const {
            data: { Vehicles = [] }
          } = await client.query({
            query: ALL_VEHICLES_SELECT_QUERY,
            variables: {
              where: {
                ...where,
                VehicleTypeRecIdRef: SystemCode.RecId
              },
              orderBy: "VehicleNumber_ASC",
              orderByMulti: ["VehicleNumber_ASC"]
            }
          });
          const sorted = Vehicles.sort((a, b) => {
            const aStatus = a.Status.CodeId;
            const bStatus = b.Status.CodeId;
            const aNumber = a.VehicleNumber;
            const bNumber = b.VehicleNumber;

            if (aStatus === "A") {
              if (bStatus === "A") {
                if (aNumber > bNumber) return 1;
                if (bNumber > aNumber) return -1;
                return 0;
              }
              return -1;
            }

            return 1;
          });
          setData(sorted);
        }
      } catch (err) {
        console.log(err.message);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [client, where]);
  return {
    data,
    loading,
    error
  };
};

function TrailerSelect({
  where,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  readOnly,
  required
}) {
  const { data, loading, error } = useTrailers(where);
  console.log(JSON.stringify(data, null, 2));
  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft={!!icon} size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : ""
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.map((Vehicle, i) => (
                <Select.Option
                  disabled={Vehicle.Status.CodeId !== "A"}
                  key={`trailer-select-${i}`}
                  value={Vehicle.RecId}
                >
                  {Vehicle.VehicleNumber}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

TrailerSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  where: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool
};

export default TrailerSelect;
